interface Props {
  total: number
  current: number                       // 0-based index of the active question
  goodSet: ReadonlySet<string>           // ids answered correctly
  badSet: ReadonlySet<string>            // ids answered incorrectly
  idsInOrder: readonly string[]         // id of each segment, in order
}

/**
 * One segment per question. Current = accent (on).
 * Answered = good (green) or bad (red). Pending = track color.
 */
export function SegBar({ total, current, goodSet, badSet, idsInOrder }: Props) {
  return (
    <div
      className="segbar"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={total}
      aria-valuenow={current + 1}
    >
      {idsInOrder.map((id, i) => {
        let cls = ''
        if (i < current) {
          cls = goodSet.has(id) ? 'good' : badSet.has(id) ? 'bad' : ''
        } else if (i === current) {
          cls = 'on'
        }
        return <i key={i} className={cls} />
      })}
    </div>
  )
}
